import ScheduleComponent from './ScheduleComponent.vue';

export default ScheduleComponent;



// WEBPACK FOOTER //
// ./src/components/parts/catalog/card/components/tabs/schedule/components/scheduleblock/index.ts